(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        var defaultBoard = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.initialSnapshot = JSON.stringify(initialState || defaultBoard);
        this.board = JSON.parse(this.initialSnapshot);
        this.status = "idle";
        this.score = 0;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(i) {
                    var row = _this.board[i];
                    var filteredRow = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                        filteredRow[j] = filteredRow[j] * 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.status = "win";
                        filteredRow.splice(j + 1, 1);
                    }
                    while(filteredRow.length < 4)filteredRow.push(0);
                    _this.board[i] = filteredRow;
                };
                if (this.status !== "playing") return;
                var deskBefore = JSON.stringify(this.board);
                for(var i = 0; i < 4; i++)_loop(i);
                var deskAfter = JSON.stringify(this.board);
                if (deskBefore !== deskAfter) this.addRandomTile();
                if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this, _loop = function(i) {
                    var row = (0, $227c6742e0ff6f82$export$71511d61b312f219)(_this.board[i]);
                    row.reverse();
                    var filteredRow = row.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                        filteredRow[j] = filteredRow[j] * 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.status = "win";
                        filteredRow.splice(j + 1, 1);
                    }
                    while(filteredRow.length < 4)filteredRow.push(0);
                    _this.board[i] = filteredRow.reverse();
                };
                if (this.status !== "playing") return;
                var deskBefore = JSON.stringify(this.board);
                for(var i = 0; i < 4; i++)_loop(i);
                var deskAfter = JSON.stringify(this.board);
                if (deskBefore !== deskAfter) this.addRandomTile();
                if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(i) {
                    var column = [
                        _this.board[0][i],
                        _this.board[1][i],
                        _this.board[2][i],
                        _this.board[3][i]
                    ];
                    var filteredRow = column.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                        filteredRow[j] = filteredRow[j] * 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.status = "win";
                        filteredRow.splice(j + 1, 1);
                    }
                    while(filteredRow.length < 4)filteredRow.push(0);
                    for(var j1 = 0; j1 < 4; j1++)_this.board[j1][i] = filteredRow[j1];
                };
                if (this.status !== "playing") return;
                var deskBefore = JSON.stringify(this.board);
                for(var i = 0; i < 4; i++)_loop(i);
                var deskAfter = JSON.stringify(this.board);
                if (deskBefore !== deskAfter) this.addRandomTile();
                if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(i) {
                    var column = [
                        _this.board[0][i],
                        _this.board[1][i],
                        _this.board[2][i],
                        _this.board[3][i]
                    ];
                    column.reverse();
                    var filteredRow = column.filter(function(num) {
                        return num !== 0;
                    });
                    for(var j = 0; j < filteredRow.length - 1; j++)if (filteredRow[j] === filteredRow[j + 1]) {
                        filteredRow[j] = filteredRow[j] * 2;
                        _this.score += filteredRow[j];
                        if (filteredRow[j] === 2048) _this.status = "win";
                        filteredRow.splice(j + 1, 1);
                    }
                    while(filteredRow.length < 4)filteredRow.push(0);
                    filteredRow.reverse();
                    for(var j1 = 0; j1 < 4; j1++)_this.board[j1][i] = filteredRow[j1];
                };
                if (this.status !== "playing") return;
                var deskBefore = JSON.stringify(this.board);
                for(var i = 0; i < 4; i++)_loop(i);
                var deskAfter = JSON.stringify(this.board);
                if (deskBefore !== deskAfter) this.addRandomTile();
                if (this.possibleMove() === false && this.status !== "win") this.status = "lose";
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "possibleMove",
            value: function possibleMove() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.board[i][j] === 0) return true;
                }
                for(var i1 = 0; i1 < 4; i1++){
                    var row = this.board[i1];
                    for(var j1 = 0; j1 < 3; j1++){
                        if (row[j1] === row[j1 + 1]) return true;
                    }
                }
                for(var i2 = 0; i2 < 4; i2++){
                    var column = [
                        this.board[0][i2],
                        this.board[1][i2],
                        this.board[2][i2],
                        this.board[3][i2]
                    ];
                    for(var j2 = 0; j2 < 3; j2++){
                        if (column[j2] === column[j2 + 1]) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.board[i][j] === 0) emptyCells.push({
                        row: i,
                        column: j
                    });
                }
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var newNumber = Math.random() < 0.9 ? 2 : 4;
                var randomCell = emptyCells[randomIndex];
                this.board[randomCell.row][randomCell.column] = newNumber;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.score = 0;
                this.status = "idle";
                this.board = JSON.parse(this.initialSnapshot);
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
document.addEventListener("DOMContentLoaded", function() {
    var render = function render() {
        var board = $197cd56b15c33885$var$game.getState();
        for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
            var number = board[i][j];
            var cell = cells[i].children[j];
            cell.textContent = number === 0 ? "" : number;
            cell.className = "field-cell";
            if (number !== 0) cell.classList.add("field-cell--".concat(number));
        }
    };
    var statusMessage = function statusMessage() {
        var statusGame = $197cd56b15c33885$var$game.getStatus();
        if (statusGame === "win") winMessage.classList.remove("hidden");
        else if (statusGame === "lose") losemessage.classList.remove("hidden");
    };
    var start = document.querySelector(".start");
    var cells = document.querySelectorAll(".field-row");
    var startMessage = document.querySelector(".message-start");
    var score = document.querySelector(".game-score");
    var winMessage = document.querySelector(".message-win");
    var losemessage = document.querySelector(".message-lose");
    var k = 1;
    start.addEventListener("click", function() {
        if (k % 2 !== 0) {
            $197cd56b15c33885$var$game.start();
            render();
            start.textContent = "Restart";
            start.classList.remove("start");
            start.classList.add("restart");
            k++;
            startMessage.classList.add("hidden");
        } else if (k % 2 === 0) {
            if (!losemessage.classList.contains("hidden")) losemessage.classList.add("hidden");
            $197cd56b15c33885$var$game.restart();
            render();
            start.textContent = "Start";
            start.classList.remove("restart");
            start.classList.add("start");
            k++;
            startMessage.classList.remove("hidden");
        }
    });
    document.addEventListener("keydown", function(e) {
        if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
        switch(e.key){
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                score.textContent = $197cd56b15c33885$var$game.getScore();
                statusMessage();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                score.textContent = $197cd56b15c33885$var$game.getScore();
                statusMessage();
                break;
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                score.textContent = $197cd56b15c33885$var$game.getScore();
                statusMessage();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                score.textContent = $197cd56b15c33885$var$game.getScore();
                statusMessage();
                break;
            default:
                return;
        }
        render();
    });
});

})();
//# sourceMappingURL=index.d310586c.js.map
